import { DeviceId, JsonValue } from "hassibot/services_v2/common/types";

export const registerDeviceWriter = (data: {
  deviceId: DeviceId;
  pushToken: string | null;
}): JsonValue => ({
  deviceId: data.deviceId,
  pushToken: data.pushToken,
});
